import type { MarketId } from '@morpho-org/blue-sdk'
import type { InterfaceInputToken } from '@morpho-org/dapp-core'

import type { Warning } from '@/components/common/WarningIcon'
import type { MarketWarningFields } from '@/types/fields'

import { InlineMarketLink } from '@/components/common/InlineEntityLinks'
import { getMarketWarningMessage } from '@/helpers/warnings'

type MarketWithWarnings = {
  marketId: MarketId
  collateralAsset: InterfaceInputToken | null
  loanAsset: InterfaceInputToken
  warnings: MarketWarningFields[]
}

/**
 * Aggregates all market warnings into a single array.
 * @param params - Parameters object
 * @param params.market - Market with warnings data
 * @param params.withMarketLink - Whether to prepend market with inline entity link (rich component)
 * @returns Array of warning objects with levels and messages
 */
export function aggregateMarketWarnings({
  market,
  withMarketLink = false
}: {
  market: MarketWithWarnings
  withMarketLink?: boolean
}) {
  const { warnings: apiWarnings } = market

  const warnings: Warning[] = []

  // Add API warnings
  apiWarnings.forEach(warning => {
    const warningMessage = getMarketWarningMessage({
      warning,
      loanAsset: market.loanAsset
    })
    if (warningMessage) {
      warnings.push({
        level: warning.level,
        message: warningMessage,
        warningType: warning.type,
        entity: withMarketLink ? <InlineMarketLink market={market} /> : undefined
      })
    }
  })

  return warnings
}
